/* The left column under the cat-builder button: the button is on screen the
   whole time, so it keeps the corner, and everything else on this edge stacks
   under it in ONE fixed flex column -- the happiness panel first, then the
   dev cat-switcher (#hud, visible only while Backquote's view is).  A column
   rather than two hand-picked `top`s because the happiness panel's height
   moves with its place list, and any fixed second top is either a
   panel-height hole or a collision waiting for the list to grow a row. */
#left-stack{position:fixed;top:62px;left:16px;z-index:2;display:flex;
  flex-direction:column;gap:10px;align-items:flex-start;
  max-height:calc(100vh - 78px);pointer-events:none}
#left-stack .panel{position:static;pointer-events:auto}
